import { Image } from "@aws-amplify/ui-react";
import * as React from "react";

export function Header() {

  return (
    <div style={{ display: "inline-flex", padding: "2rem" }}>
      <Image
        alt="logo"
        src={require("assets/img/Logo_Mirth.svg").default}
        className="mr-3"
        placeholder={undefined}
      />
      <Image
        alt="logo"
        style={{ width: "335px" }}
        src={require("assets/img/MCC_Logo_Text.svg").default}
        placeholder={undefined}
      />
    </div>
  );
}
